import React from "react";

function DateRange({ label, name, filter, setFilter }) {
  return (
    <>
      <div className="form-column">
        <div className="form-group">
          <label>{label}:</label>
          <input
            type="date"
            name={name}
            required
            value={filter[name]}
            onChange={(e) => {
              const value = e.target.value;

              setFilter({
                [name]: value,
              });
            }}
          />
        </div>
      </div>
    </>
  );
}

export default DateRange;
